import '@/utils/user.env.js';
import Vue from 'vue';
import mui from 'mui';
import App from './App.vue';
import router from './router';
import store from '../../store/index';
import JsDynamicLoader from '@midea/js-dynamic-loader';

import '../../utils/directive/highlight';
import '../../utils/directive/display';
// import { checkLogin } from '../../utils/index';
// import '@midea/mui/dist/styles/mui.css';
import '@/styles/mui.css';
import '../../styles/base.less';
import userConfig from '@/config/user.env';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import globalMixin from '@/mixin/globalMixin.js';
import { loadVueComponents } from '@/utils/loadVueComponents';
// import globalMixin from '@/mixin/globalMixin.js';

Vue.config.productionTip = false;
Vue.component('staff-selector', () => JsDynamicLoader(userConfig.staffSelector.url));
Vue.component('m-ueditor', () => JsDynamicLoader(userConfig.uEditor.url));
Vue.use(VueAwesomeSwiper);
// Vue.mixin(globalMixin);
// checkLogin(router); // 改成用接口判断是否登录
Vue.mixin(globalMixin);
store.dispatch('UPDATE_LANG').then(i18n => {
  Vue.use(mui, {
    i18n: (path, options) => {
      const value = i18n.t(path, options);
      if (value) return value;
      return '';
    },
  });
  window.vue = Vue;
  window.Vue = Vue;
  loadVueComponents(['/int/static/muiSelect/MideaSelector.min.js'], function () {
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
    }).$mount('#app');
  });
});
